/**
 * Dashboard Service
 * API calls for dashboard statistics
 */

import { apiConfig } from '../config/api';

const BASE_URL = apiConfig.brandsApi;

export interface ProductStats {
  total: number;
  active: number;
  inactive: number;
}

export interface TopCombination {
  id: string;
  imageUrl: string;
  viewCount: number;
  productCount: number;
  createdAt: string;
}

export interface CombinationStats {
  total: number;
  topCombinations: TopCombination[];
}

export interface FeatureUsage {
  featureCode: string;
  featureName: string;
  usageCount: number;
  baseQuota: number;
  remaining: number;
  usagePercentage: number;
}

export interface DashboardStats {
  products: ProductStats;
  combinations: CombinationStats;
  featureUsage: FeatureUsage[];
}

export class DashboardService {
  /**
   * Get dashboard statistics for a brand
   */
  static async getDashboardStats(brandId: string): Promise<DashboardStats> {
    try {
      const response = await fetch(`${BASE_URL}/api/v1/brands/${brandId}/dashboard-stats`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch dashboard stats');
      }

      if (!data.success || !data.data) {
        throw new Error('Invalid API response');
      }

      return data.data;
    } catch (error) {
      console.error('Failed to fetch dashboard stats:', error);
      
      // Return default/empty data on error
      return {
        products: {
          total: 0,
          active: 0,
          inactive: 0
        },
        combinations: {
          total: 0,
          topCombinations: []
        },
        featureUsage: []
      };
    }
  }
}

